module.exports = __webpack_public_path__ + "img/psywel78a4j7591fek1nv2kc8kh8365iiub2cb6ab9-0268-4bdf-a2d8-bcabf0b8ec0f.3b879562.png";